import { render, staticRenderFns } from "./MTotalPrice.vue?vue&type=template&id=fad1c344&"
import script from "./MTotalPrice.vue?vue&type=script&lang=ts&"
export * from "./MTotalPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports